module.exports = __webpack_public_path__ + "c06ef7d0618431897c419b704f7ec40b.svg";